<template>
  <div class="test-view test-details-view past-test-student-view qiid-question-past-test c-18-may institute-question-view">
    <div>
      <v-breadcrumbs>
        <template>
          <v-breadcrumbs-item>
            <span class="light-text">Customization / </span>
          </v-breadcrumbs-item>
          <v-breadcrumbs-item>
            <span class="light-text"> {{ breadcrumb }} /</span>
          </v-breadcrumbs-item>
          <v-breadcrumbs-item>
            <span class="light-text">
              {{ currentQuestion ? currentQuestion.question_id : "" }}</span>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <div class="test-page-section qiid-question-view">
      <div class="test-btn-quection">
        <v-card class="mx-auto normal-card live-test-hg" ref="testBlock">
          <pinch-zoom class="pinch-zoom" disableZoomControl="disable" :wheel="false">
            <div class="tst-quection-block directorpriviewtest click-upload-replace-outer" ref="questionBox" style="height: calc(100vh - 230px) !important;">
              <div v-if="questionData && questionTypes">
                <div v-if="isEditing" class="without-upload-&-replace-height-control">
                  <div>
                    <div class="chapter-name-row click-upload-replace">
                      <div class="cha-Upload-row">
                        <div class="chapter-label cha-Upload-label-1">
                          Chapter Name
                          <span>*</span>
                        </div>
                        <div class="chapter-drop">
                          <v-select v-model="selectedChapter" @change="onSelectChapter" :items="chapters" hide-details
                            dense outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                        </div>

                        <div class="chapter-label cha-Upload-label-1" v-if="isDBTest">
                          SubTopic
                          <!-- <span>*</span> -->
                        </div>
                        <div class="chapter-drop" v-if="isDBTest">
                          <v-select v-model="selectedSubTopic" @change="onSelectedSubTopic" :items="subTopics"
                            hide-details dense outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                        </div>

                        <div v-if="isDBTest" class="chapter-label cha-Upload-label-1">
                          Level
                          <span>*</span>
                        </div>
                        <div v-if="isDBTest" class="chapter-drop">
                          <v-select v-model="selectedDifficultyLevel" @change="onselectedDifficulty" :items="difficulty"
                            hide-details dense outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                        </div>
                      </div>
                      <div class="cha-Upload-row" v-if="isDBTest">
                        
                        <div class="chapter-label cha-Upload-label-1">
                          Topic Name
                          <!-- <span>*</span> -->
                        </div>
                        <div class="chapter-drop">
                          <v-select v-model="selectedTopic" @change="onSelectedTopic" :items="topics" hide-details dense
                            outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                        </div>

                        <div class="chapter-label cha-Upload-label-1">
                          Concept
                          <!-- <span>*</span> -->
                        </div>
                        <div class="chapter-drop">
                          <v-select v-model="selectedConcept" @change="onSelectedConcept" :items="concepts" hide-details
                            dense outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                        </div>

                        <div class="chapter-label cha-Upload-label-1">
                          Skillset
                          <span>*</span>
                        </div>
                        <div class="chapter-drop">
                          <v-select v-model="selectedSkillSet" :items="skillset" @change="onselectedSkillset"
                            hide-details dense outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="upload-replace-scrooalble">
                    <SingleAnsQue :showNextButton="showNextButton" :question="currentQuestionToBeEdited"
                      :isEditable="isEditable" v-if="
                        currentQuestion.question_type == questionTypes.SINGLE_CORRECT ||
                        currentQuestion.question_type ==
                        questionTypes.SINGLE_CORRECT_SEC2 ||
                        currentQuestion.question_type == questionTypes.ASSERTION_REASON
                      " />

                    <MultipleCorrect :showNextButton="showNextButton" :question="currentQuestionToBeEdited"
                      :isEditable="isEditable" v-if="
                        currentQuestion.question_type == questionTypes.MULTIPLE_CORRECT
                      " />
                    <Integer :showNextButton="showNextButton" :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="currentQuestion.question_type == questionTypes.INTEGER" />
                    <Subjective :showNextButton="showNextButton" :isEditable="isEditable"
                      :question="currentQuestionToBeEdited" v-if="
                        currentQuestion.question_type == questionTypes.SUBJECTIVE ||
                        currentQuestion.question_type == questionTypes.SUBJECTIVEINTEGER
                      " />
                    <MatrixMatch :showNextButton="showNextButton" :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH" />
                    <MatrixMatchOption :showNextButton="showNextButton" :isEditable="isEditable"
                      :question="currentQuestionToBeEdited" v-if="
                        currentQuestion.question_type ==
                        questionTypes.MATRIX_MATCH_OPTION
                      " />
                    <Comprehensions :showNextButton="showNextButton" :isEditable="isEditable"
                      :question="currentQuestionToBeEdited" v-if="
                        currentQuestion.question_type == questionTypes.COMPREHENSION
                      " />
                    <TC :showNextButton="showNextButton" :isEditable="isEditable" :question="currentQuestionToBeEdited"
                      v-if="currentQuestion.question_type == questionTypes.TC" />
                  </div>
                </div>
                <div :class="$refs.previewName
                  ? $refs.previewName.offsetHeight > 52
                    ? 'preview-test-6feb'
                    : ''
                  : ''
                  " v-else>
                  <div ref="previewName"
                    class="chapter-name-row print-name preview-test-dropdown-block test-preivew-1-feb" v-if="isPreview">
                    <div class="chapter-name-outer-cp3">
                      <div class="chapter-name-row-cp3">
                        <div class="chapter-label search-another-label">
                          Chapter Name -
                        </div>

                        <div class="chapter-drop search-another-drop" v-if="!isSearchAnotherQ">
                          <v-tooltip left bottom content-class="cust-new-tooltip-top open-top">
                            <template v-slot:activator="{ on }">
                              <div v-on="on" depressed :class="{
                                'text-transform-none': true,
                                'btn-center': true,
                                'btn-default': true,
                              }">
                                {{ currentQuestion.chapterName }}
                              </div>
                            </template>
                            <span> {{ currentQuestion.chapterName }} </span>
                          </v-tooltip>
                        </div>
                        <div v-if="
                          currentQuestion.topicName &&
                          !isSearchAnotherQ &&
                          this.isDBTest
                        " class="chapter-label search-another-label-2">
                          Topic Name -
                        </div>
                        <div class="chapter-drop search-another-drop" v-if="
                          currentQuestion.topicName &&
                          !isSearchAnotherQ &&
                          this.isDBTest
                        ">
                          <v-tooltip left bottom content-class="cust-new-tooltip-top open-top">
                            <template v-slot:activator="{ on }">
                              <span v-on="on" depressed :class="{
                                'text-transform-none': true,
                                'btn-center': true,
                                'btn-default': true,
                              }">{{ currentQuestion.topicName }}</span>
                            </template>
                            <span> {{ currentQuestion.topicName }} </span>
                          </v-tooltip>
                        </div>
                        <div class="chapter-label search-another-label-3" v-if="
                          currentQuestion.difficultyName &&
                          !isSearchAnotherQ &&
                          this.isDBTest
                        ">
                          Level -
                        </div>

                        <div class="chapter-drop search-another-drop" v-if="
                          currentQuestion.difficultyName &&
                          !isSearchAnotherQ &&
                          isDBTest
                        ">
                          <v-tooltip left bottom content-class="cust-new-tooltip-top search-another-drop-easy open-top">
                            <template v-slot:activator="{ on }">
                              <span v-on="on" depressed :class="{
                                'text-transform-none': true,
                                'btn-center': true,
                                'btn-default': true,
                              }">{{ currentQuestion.difficultyName }}</span>
                            </template>
                            <span> {{ currentQuestion.difficultyName }} </span>
                          </v-tooltip>
                        </div>
                        <div class="chapter-name-row isSearchAnothe-chapter" v-if="isSearchAnotherQ">
                          <div class="isSearchAnothe-chapter-col ch-margin-btn-10">
                            <div class="chapter-label">Chapter Name</div>
                            <div class="chapter-drop">
                              <v-select v-model="selectedChapter" @change="getTopics()" :items="chapters" hide-details
                                dense outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                            </div>

                            <div class="chapter-label chapter-label-2">Topic Name</div>
                            <div class="chapter-drop">
                              <v-select v-model="selectedTopic" @change="getSubTopics()" :items="topics" hide-details
                                dense outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                            </div>

                            <div class="chapter-label chapter-label-3">Level</div>
                            <div class="chapter-drop">
                              <v-select v-model="selectedDifficultyLevel" :items="difficulty" hide-details dense
                                outlined ref="chapterName" class="dropdown-fix-160"></v-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="btn-search-another-question last-used" v-if="isPreview && !currentQuestion.institute_id">
                      <v-btn v-if="!this.bookmarkQuestion && !isEditable" color="primary" class="cust-btn right-align"
                        @click="addBookmark()">Bookmark Question
                      </v-btn>
                      <v-btn v-if="this.bookmarkQuestion && !isEditable" color="#E9E8E7" class="cust-btn right-align disabled-btn"
                        @click="removeBookmarkDialog()">Remove Bookmark
                      </v-btn>
                    </div>
                  </div>
                  <div class="cp3privew-test-bk cp3-17-april" :class="{
                    'without-search-height-control': !isSearchAnotherQ,
                    'with-search-height-control': isSearchAnotherQ,
                  }">
                    <ComprehensionMultiple :showAnswerField="true" :currentQuestion="currentQuestion" :isPreview="isPreview"
                      v-if="
                        currentQuestion.question_type == questionTypes.COMPREHENSION ||
                        currentQuestion.question_type == questionTypes.TC
                      " />
                    <SingleAnsQuePrivew :showAnswerField="true" :currentQuestion="currentQuestion" v-if="
                      currentQuestion.question_type == questionTypes.SINGLE_CORRECT ||
                      currentQuestion.question_type ==
                      questionTypes.SINGLE_CORRECT_SEC2 ||
                      currentQuestion.question_type == questionTypes.ASSERTION_REASON
                    " />
                    <MultipleCorrectPrivew :showAnswerField="true" :currentQuestion="currentQuestion" v-if="
                      currentQuestion.question_type == questionTypes.MULTIPLE_CORRECT
                    " />
                    <IntegerPrivew :showAnswerField="true" :currentQuestion="currentQuestion" :isPreview="isPreview"
                      v-if="currentQuestion.question_type == questionTypes.INTEGER" />
                    <SubjectivePrivew :showAnswerField="true" :currentQuestion="currentQuestion" :isPreview="isPreview"
                      v-if="
                        currentQuestion.question_type == questionTypes.SUBJECTIVE ||
                        currentQuestion.question_type == questionTypes.SUBJECTIVEINTEGER
                      " />
                    <MatrixMatchPrivew :showAnswerField="true" :currentQuestion="currentQuestion"
                      v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH" />

                    <MatrixMatchOptionPrivew :showAnswerField="true" :currentQuestion="currentQuestion" v-if="
                      currentQuestion.question_type ==
                      questionTypes.MATRIX_MATCH_OPTION
                    " />
                  </div>
                </div>
              </div>
            </div>
          </pinch-zoom>
        </v-card>
      </div>
      <div class="test-counter-block pasterrorblk show-desktop-panel">
        <div class="test-time-count">
          <div class="time-remaining-title">
            <!-- <v-btn color="primary" class="cust-btn right-align" @click="openReportErrorDialog"
              v-if="currentQuestion.institute_id === null">Report Error</v-btn> -->
          </div>
        </div>
        <div class="inner-block">
          <div :class="[
            !checkBoostupSubscription() && !isOnlineInstitute ? 'expansion-panel-height-alti' : '', 'number-contet', 'scrollable-video'
          ]">
            <VideoList :videoList="videoList" :test_id="testDetailId" :question_id="currentQuestion.id" />
          </div>

        </div>


      </div>
    </div>

    <div class="test-bottom logo-btm">
      <div class="bottom-logo">
        <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
      </div>
      <div class="test-btn-block-answering v-r-priview-test-view">
        <div class="save-and-next-btn save-finish-btn">
          <div class="mobile-upload-btn">
            <v-btn
                v-if="
                  isPreview &&
                  breadcrumb === 'Bookmarked Questions' &&
                  currentQuestion.institute_id === null
                "
                :disabled="isEditing"
                color="primary"
                @click="openReportErrorDialog()"
                class="cust-btn"
              >
                Report Error
              </v-btn>
            <v-btn color="primary" v-if="
              isPreview &&
              currentQuestion.institute_id !== null &&
              breadcrumb === 'Institute Questions' &&
              (currentQuestion.created_by === user.id || user.role_id === userRoles.ID || user.role_id === userRoles.CO)
            " @click="editQuestion" class="cust-btn">{{ isEditing ? "Done" : "Edit" }}</v-btn>
          </div>

          <v-btn v-if="isPreview && !isLastQuestion()" color="primary" :disabled="isEditing" @click="nextQuestion()"
            class="cust-btn right-align">
            Next
          </v-btn>
        </div>
        <div class="finish-test-btn">
          <v-btn color="default" class="cust-btn finish-test" @click="closeQuestionPreview()">Close Preview</v-btn>
        </div>
      </div>
    </div>
    <div class=" test-counter-block pasterrorblk may-18 show-mobile-panel">
      <div class="test-time-count-1">
        <div class="time-remaining-title">
          <!-- <v-btn color="primary" class="cust-btn right-align" @click="openReportErrorDialog"
            v-if="currentQuestion.institute_id === null">Report Error</v-btn> -->
        </div>
      </div>
      <div class="inner-block">
        <div class="number-contet scrollable-video">
          <VideoList :videoList="videoList" :test_id="testDetailId" :question_id="currentQuestion.id" />
        </div>

      </div>
    </div>
    <AlertBox :width="modalWidth" :onClose="onClose" :component="cComponent" :status="status" :data="alertBoxData" />
  </div>
</template>



<script>
import { Carousel, Slide } from "vue-carousel";
import * as youtubeSearch from "youtube-search";
import ProgressBar from "@/components/common/ProgressBar.vue";

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPastTest from "@/components/PreviewTest/LegendsPastTest.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import ComprehensionMultiple from "@/components/PreviewTest/ComprehensionMultiple.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";
import VideoList from "@/components/common/VideoList.vue";
import constants from "@/utils/constants.js";
import moment from "moment";

// importing components for edit mode
import SingleAnsQue from "@/components/QuestionType/SingleAnsQue.vue";
import MultipleCorrect from "@/components/QuestionType/MultipleCorrect.vue";
import Subjective from "@/components/QuestionType/Subjective.vue";
import Integer from "@/components/QuestionType/Integer.vue";
import MatrixMatchOption from "@/components/QuestionType/MatrixMatchOption.vue";
import MatrixMatch from "@/components/QuestionType/MatrixMatch.vue";
import Comprehensions from "@/components/QuestionType/Comprehensions.vue";
import TC from "@/components/QuestionType/TC.vue";

export default {
  name: "ExternalQuestionView",
  components: {
    QuestionPallet,
    MiniQuestionPallet,
    LegendsPastTest,
    LegendsOnHover,
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew,
    Carousel,
    Slide,
    ProgressBar,
    VideoList,
    SingleAnsQue,
    MultipleCorrect,
    Subjective,
    Integer,
    MatrixMatchOption,
    MatrixMatch,
    Comprehensions,
    TC,
    ComprehensionMultiple,
  },
  created() {
    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
  },
  async mounted() {
    if (this.$route.params.requiredCall == "personal-questions") {
      this.breadcrumb = "Institute Questions";
    }
    if (this.$route.params.requiredCall == "bookmark-questions") {
      this.breadcrumb = "Bookmarked Questions";
    }

    let filter = localStorage.getItem(`questionDetailFilter_${this.$route.params.requiredCall}`)
    this.page = 1
    if (filter) {
      this.page = JSON.parse(filter)?.pagination?.page
    }

    this.getQuestion();
    localStorage.removeItem('prevPath');
    localStorage.setItem('prevPath', this.$route.name);
  },
  data() {
    return {
      isShowReportErrorBtn: true,
      status: false,
      question: [],
      expansionPanelStatus: null,
      subTopicName: "",
      videoList: {
        taggedConcepts: [],
        mainConcept: [],
        subTopic: [],
      },
      selectedSubject: "",
      QIdView: true,
      bookmarkQuestion: false,
      subjectQuestionTypeList: [],
      page: 1,
      pageCount: {},
      breadcrumb: "",
      testDetailId: null,
      isDisabled: false,
      customPageSizeForQuesView: null,

      breadcrumb: '',
      isPastTest: false,
      is_preview: true,
      modalWidth: "1000px",
      instructionsTooltip: null,
      cComponent: "components/coordinator/Questionadd",
      alertBoxData: {},
      persistent: false,
      status: false,
      testDetails: null,
      questionTypes: this.QUE_TYPES,
      questionStatus: this.QUESTION_STATUS,
      questionStatusColor: this.QUESTION_STATUS_COLOR,
      questionTypesReversed: {},
      questionsList: {},
      questionData: {},
      panel: 0,
      questions: [],
      currentQuestion: {},
      legendsData: {
        answered: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
        notVisited: 0,
        notAnswered: 0,
        easy: 0,
        moderate: 0,
        tough: 0,
      },
      instructions: "",
      isEditing: false,
      currentQuestionToBeEdited: {},
      showNextButton: false,
      isTestCustom: true,
      isPreview: true,
      scrollPerPage: false,
      direction: "",
      endAction: "",
      duration: null,
      timeRemainingString: "",
      timeRemainingInterval: null,
      heartBeatInterval: null,
      isOnline: true,
      timeObj: null,
      chapters: [],
      perPageCustom: [
        [1900, 6],
        [1650, 5],
        [1550, 4],
        [1400, 3],
        [1300, 3],
        [1280, 3],
        [1024, 2],
        [768, 2],
        [480, 1],
        [340, 1],
      ],
      pageStatus: [],
      pageInactive: false,
      inactiveStartTime: null,
      nextQuestionIndex: 0,
      showNextQuestion: true,
      isSQTChanged: false,
      isAnswerBtnClicked: false,
      scrollQtypeValue: null,
      isBlurred: false,
      hideTimer: false,
      finishTestError: null,
      responseTimeOut: null,
      cancelBeatSource: null,
      showTimer: false,
      expansionPanelStatus: [],
      remainingTimeInterval: null,
      testAutoFinished: false,
      topics: [],
      concepts: [],
      skillset: [],
      selectedTopic: {},
      difficulty: constants.DIFFICULTY_LEVELS,
      studentResponse: constants.ROLES.ST_ROLE_CODE,
      selectedDifficultyLevel: {},
      selectedSubTopic: {},
      selectedConcept: {},
      searchAnotherQuestions: {},
      isSearchAnotherQ: false,
      isUploadAndReplace: false,
      isEditable: false,
      teacherSubjectId: [],
      dummyOptionsPQR: [],
      dummyOptions: [],
      dummyOptionsABC: [],
      AssignedTeacher: [],
      questionAnsweredCount: 0,
      isCallBucketApi: false,
      isDBTest: true,
      isOnlineTest: true,
      noOfTimesTabChanged: 0,
      autoSubmitEndAction: "",
      autoSubmitError: "",
      navigateTo: 0,
      isApiCall: true,
      pageBlurredTrigger: null,
      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      browserPrefixes: ["moz", "ms", "o", "webkit"],
      isVisible: true, // internal flag, defaults to true
      browserPrefix: null,
      hiddenPropertyName: null,
      visibilityEventName: null,
      maxHeight: 0,
      paperCoverage: {},
      showTags: false,
      bookmarkQuestion: false,
      userRoles: constants.ROLES_ID
    };
  },
  computed: {
    ...mapGetters("testStore", {
    }),
    ...mapState("userStore", ["user", 'myInstitute']),
    isOnlineInstitute() {
      return constants.institute_ids.includes(this.myInstitute.id)
    }
  },
  watch: {
    "currentQuestion.id": function (currentQuestion) {
      // this.getMainConceptVideos();
      // this.getSubTopicVideos();
    },
    '$route.params': function (value) {
    }
  },
  methods: {
    ...mapActions({
      getExternalQuestionsList: "questionStore/getExternalQuestionsList",
      editExternalQuestion: "questionStore/editExternalQuestion",
      addBookmarkQuestion: "testStore/addBookmarkQuestion",
      removeBookmarkQuestion: "testStore/removeBookmarkQuestion",
      getAttemptedQuestions: "testStore/getAttemptedQuestions",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getRefData: "utilStore/getRefData",
    }),
    ...mapMutations("app", ["addBreadCrumbChilde"]),

    isLastQuestion() {
      if (this.page == this.pageCount.rowCount) {
        return true;
      } else {
        return false;
      }
    },

    getQuestion() {
      let question_filter = JSON.parse(localStorage.getItem(`questionDetailFilter_${this.$route.params.requiredCall}`))
      let postData = question_filter;
      postData.question_details_required = true
      postData.pagination = {
        page: this.page,
        pageSize: 1,
      }
      // if (question_filter) {
      //   if (question_filter.subject_id) {
      //     postData.subject_ids = [question_filter.subject_id]
      //   }
      //   if (question_filter.chapter_id) {
      //     postData.chapter_ids = question_filter.chapter_id

      //   }
      //   if (question_filter.topic_id && question_filter.topic_id.length) {
      //     postData.topic_ids = question_filter.topic_id

      //   }
      //   if (question_filter.question_types.length > 0) {
      //     postData.question_types = question_filter.question_types;
      //   }
      //   if (question_filter.filterby && question_filter.filterby === 'my_questions') {
      //     postData.filter_by = 'me'
      //   }
      //   if (question_filter.question_id) {
      //     postData.search_question_id = question_filter.question_id
      //   }
      //   postData.orderBy = question_filter.orderBy;
      // }
      if (this.$route.params.requiredCall === 'personal-questions') {
        postData.category = "personal_questions"
      }
      if (this.$route.params.requiredCall === 'bookmark-questions') {
        postData.category = "bookmark_questions"
      }
      this.$root.showLoader = true;

      this.getExternalQuestionsList(postData)
        .then((response) => {
          this.question = response.list;
          this.pageCount = response.pagination;
          this.processQuestion(response.list);
          this.currentQuestion.questionNo = response.pagination.page;
          this.$root.showLoader = false;
          if (this.compareEvent(constants.EVENT.CREATE_PRACTICE_SESSION)) {
            this.removeEvent()
            this.requestCreateTest();
          }
          setTimeout(async () => await this.renderMath(), 100)

        })
        .catch((err) => {
          console.log(err);
          this.$root.showLoader = false;
        });
    },
    processQuestion(questionData) {

      try {
        const mainQuestion = questionData[0];
        let parentQuestion = null;
        let q = mainQuestion.question_details.find(q => q.id == mainQuestion.question_id); // current question in loop
        this.bookmarkQuestion = q.question_bookmark == 1 ? true : false;
        this.subjectQuestionTypeList = [...mainQuestion.question_details]; // current question in loop
        q.user_selected_answer = questionData[0].yourAnswer;
      
      let questionTypeId = q.question_type;
      if (questionTypeId === this.questionTypes.COMPREHENSION || questionTypeId === this.questionTypes.TC) {

        parentQuestion = mainQuestion.question_details.find(qt => qt.parent_id == null);
        if(!q.subtype && parentQuestion.subtype) {
          q.subtype = parentQuestion?.subtype;
        }
        questionTypeId = q?.subtype?.id || q.subtype;
      } else {
        questionTypeId = q.question_type;
      }
      let currentQuestion = {};
      currentQuestion = this.generateQuestionObject(questionTypeId, q);
      currentQuestion.subtype = q.subtype ? q.subtype.id ? q.subtype.id : q.subtype : '';
      if (
        q.question_type == this.questionTypes.COMPREHENSION ||
        q.question_type == this.questionTypes.TC
      ) {
        currentQuestion.passage = q.passage;
      }
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      currentQuestion.question_id = mainQuestion.question_id;
      currentQuestion.chapterName = q.chapter_title;
      currentQuestion.chapterHealth = q.chapter_health;
      currentQuestion.topicName = q.topic_title;
      currentQuestion.topicHealth = q.topic_health;
      currentQuestion.level = q.datatype.level;
      currentQuestion.conceptName = q.concept_title;
      currentQuestion.subTopicName = q.subtopic_title;
      currentQuestion.institute_id = q.institute_id;
      currentQuestion.solution = q.solution;
      currentQuestion.isPreview = true;
      currentQuestion.difficultyName = q.difficultyName
        ? q.difficultyName
        : this.difficulty.find(d => d.id === q.difficulty)?.title || "";
      currentQuestion.difficultyId = q.difficultyId
        ? q.difficultyId
        : this.difficulty.find(d => d.id === q.difficulty)?.id || 0;
      currentQuestion.difficulty = q.difficultyId
        ? q.difficultyId
        : this.difficulty.find(d => d.id === q.difficulty)?.id || 0;
      currentQuestion.questionNo = this.page;
      this.currentQuestion = currentQuestion;


      this.getChapters(
        this.currentQuestion.subjectId,
        this.currentQuestion.subtype
      );

      this.selectedChapter = {
        chapter_id: this.currentQuestion.chapterId,
        title: this.currentQuestion.chapterName,
      };
      this.getTopics(this.selectedChapter.chapter_id);

      this.selectedTopic = {
        topic_id: this.currentQuestion.topic_id,
        title: this.currentQuestion.topicName,
      };
      this.getSubTopics(this.currentQuestion.topic_id);

      this.selectedDifficultyLevel = {
        id: this.currentQuestion.difficultyId,
        title: this.currentQuestion.difficultyName,
      };

      this.selectedSkillSet = {
        id: this.currentQuestion.answer_type,
        title: this.currentQuestion.skillsetName,
      };
      this.getSkillSets(this.currentQuestion.answer_type)

      this.selectedSubTopic = {
        subtopic_id: this.currentQuestion.subtopic_id,
        title: this.currentQuestion.subtopicName,
      };
      this.getConcepts(this.currentQuestion.subtopic_id);

      this.selectedConcept = {
        concept_id: this.currentQuestion.concept_id,
        title: this.currentQuestion.conceptName,
      };
      this.getSubTopics(this.currentQuestion.topic_id)

      switch (this.currentQuestion.question_type) {
        case this.questionTypes.INTEGER:
          this.currentQuestion.correct_answer = q.correct_answer;
          break;
        
        case this.questionTypes.MATRIX_MATCH:
        this.currentQuestion.options_abc = q.options.filter(
          (o) => o.column == 1
        );
        this.currentQuestion.options_pqr = q.options.filter(
          (o) => o.column == 2
        );
        break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          this.currentQuestion.options_abc = q.options.filter(
            (o) => o.column == 1
          );
          this.currentQuestion.options_pqr = q.options.filter(
            (o) => o.column == 2
          );
          this.currentQuestion.options = q.options.filter(
            (o) => o.column == null
          );
          break;

        case this.questionTypes.COMPREHENSION:
          this.currentQuestion.passage = parentQuestion.question_text;
          this.currentQuestion.childQuestions = mainQuestion.question_details.filter(q => q.parent_id == parentQuestion.id);
          this.currentQuestion.childQuestions.forEach(question => {
            question.disabled = true;
            if(!question.subtype && q.subtype) {
              question.subtype = q?.subtype;
            }
            question.subtype = question.subtype ? question.subtype.id ? question.subtype.id : question.subtype : '';
            if(question.subtype == this.questionTypes.COMPREHENSION_2Q_NU) {
              question.correct_answer = question.correct_answer;
              question.startValue = question.correct_answer.split("##")[0];
              question.endValue = question.correct_answer.split("##")[1];
            }
          });
          break;

        case this.questionTypes.TC:
          this.currentQuestion.passage = parentQuestion.question_text;
          this.currentQuestion.childQuestions = mainQuestion.question_details.filter(q => q.parent_id == parentQuestion.id);
          this.currentQuestion.childQuestions.forEach(question => {
            question.disabled = true;
            if(!question.subtype && q.subtype) {
              question.subtype = q?.subtype;
            }
            question.subtype = question.subtype ? question.subtype.id ? question.subtype.id : question.subtype : '';
          });
          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
          this.currentQuestion.correct_answer = q.correct_answer;
          this.currentQuestion.startValue = this.currentQuestion.correct_answer.split("##")[0];
          this.currentQuestion.endValue = this.currentQuestion.correct_answer.split("##")[1];
          break;

        case this.questionTypes.ASSERTION_REASON:
          this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.SINGLE_CORRECT:
        case this.questionTypes.SINGLE_CORRECT_SEC2:
          this.currentQuestion.options = q.options;
            break;
        }
      } catch (error) {
        console.log(error);
        this.closeQuestionPreview()
      }
    },
    getVideos(noOfVideos, searchText) {
      return new Promise((resolve, reject) => {
        var opts = {
          maxResults: noOfVideos,
          key: this.YOUTUBE_SEARCH_API_KEY, // change key once deploying on prod from google apis by creating a new project
        };
        let searchTextt = this.selectedSubject + " " + searchText;
        youtubeSearch(searchTextt, opts, (err, results) => {
          if (err) {
            resolve(false);
          }
          resolve(results);
        });
      });
    },
    async getSubTopicVideos() {
      if (
        this.currentQuestion.subTopicName &&
        this.currentQuestion.subTopicName == "General"
      ) {
        return;
      }
      let subTopicName = this.currentQuestion.subTopicName
        ? this.currentQuestion.subTopicName.substr(
          this.currentQuestion.subTopicName.indexOf(".") + 1
        )
        : null;
      if (subTopicName) {
        let videos = await this.getVideos(4, subTopicName);
        this.videoList.subTopic = videos;
      }
    },
    async getTaggedConceptVideos() {
      let tc = [];
      if (
        this.currentQuestion.taggedConcepts &&
        this.currentQuestion.taggedConcepts.length
      ) {
        for (let i = 0; i < this.currentQuestion.taggedConcepts.length; i++) {
          const t = this.currentQuestion.taggedConcepts[i];
          if (t.tag != "No Video" && t.tag != "Source_Booklet") {
            let videos = await this.getVideos(
              2,
              t.tag.substr(t.tag.indexOf(".") + 1)
            );
            tc.push({
              tag: t.tag.substr(18),
              videos,
            });
          }
        }
      }
      if (tc && tc.length) {
        this.videoList.taggedConcepts = tc;
      }
    },
    async getMainConceptVideos() {
      if (
        this.currentQuestion.conceptName &&
        this.currentQuestion.conceptName == "General"
      ) {
        return;
      }
      let conceptName = this.currentQuestion.conceptName
        ? this.currentQuestion.conceptName.substr(
          this.currentQuestion.conceptName.indexOf(".") + 1
        )
        : null;
      if (conceptName) {
        let videos = await this.getVideos(2, conceptName);
        this.videoList.mainConcept = videos;
      }
    },
    closeQuestionPreview() {
      if (this.isEditing) {
        return this.$toasted.error(
          "The changes you have made to this question have not been saved. Please click on Done to save the changes."
        );
      } else {
        let route = this.$route.params.requiredCall;
        if (route === 'bookmark-questions') {
          this.$router.push({ name: 'bookmark-questions' });
        }
        if (route === "personal-questions") {
            this.$router.push({ name: 'personal-questions' });
        }
      }

    },
    openReportErrorDialog() {
      this.alertBoxData = {
        question: this.currentQuestion,
        errorDescription: "",
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/ReportError";
      this.$forceUpdate();
    },
    async nextQuestion() {
      this.page = parseInt(this.page) + 1;
      this.getQuestion();
    },
    getCurrentQuestionCommonKeys(currentQuestion, q) {
      currentQuestion.id = q.id;
      currentQuestion.question_text = q.question_text;
      currentQuestion.question_id = q.question_id;
      currentQuestion.question_type = q.question_type;
      currentQuestion.questionType = { id: q.question_type };
      currentQuestion.parent_id = q.parent_id;
      currentQuestion.section_id = q.section_id;
      currentQuestion.test_detail_id = q.test_detail_id;
      currentQuestion.correct_marks = q.marks;
      currentQuestion.negative_marks = q.negative_marks;
      currentQuestion.partial_marking = q.partial_marking;
      currentQuestion.solution = q.solution;
      currentQuestion.hints = q.hints;
      currentQuestion.isBonus = q.is_bonus;
      currentQuestion.created_by = q.created_by;
      currentQuestion.userSelectedAnswer = q.user_selected_answer;
      currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
      currentQuestion.isAnswered = false; // to know if the current question is answered.
      currentQuestion.disabled = true;
      currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.NOT_ATTEMPTED;
      currentQuestion.institute_id = q.institute_id;
      currentQuestion.chapterId = q.datatype.id;
      currentQuestion.subjectId = q.datatype.parent;
      currentQuestion.topic_id = q.topic_id;
      currentQuestion.concept_id = q.concept_id;
      currentQuestion.subType = q.subtype;
      currentQuestion.subtopic_id = q.subtopic_id;
      currentQuestion.subtopicName = q.subtopic_title;
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.skillsetName = q.answertype ? q.answertype.value : "";

      let om = q.obtained_mark ? q.obtained_mark : 0;
      currentQuestion.obtained_mark = om;
      let marks = q.marks;

      if (q.user_selected_answer) {
        let answer = q.user_selected_answer;
        currentQuestion.isAnswered = answer.answer ? true : false;
        currentQuestion.status = answer.status;
      }
      if (currentQuestion.institute_id == null) {
        this.isShowReportErrorBtn = false;
      }
      if (om == marks) {
        currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.CORRECT;
      } else if (om > 0 && om < marks) {
        currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT;
      } else if (currentQuestion.isAnswered && om < 1) {
        currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.INCORRECT;
      }
      return currentQuestion;
    },
    getCQRType1(type, q) {
      let responseData = {
        options: [],
        yourAnswer: "",
        correctAnswer: "",
      };
      let correctOptions = _.cloneDeep(q.options);
      let correctAnswer = [];
      let yourAnswer = [];
      let options = q.options.map((o) => {
        return { ...o };
      });

      correctOptions.forEach((o) => {
        if (parseInt(o.correct_answer)) {
          correctAnswer.push(o.index);
        }
      });

      if (q.user_selected_answer) {
        let option = null;
        let answer = JSON.parse(q.user_selected_answer);
        if (answer.answer) {
          let switchType = 1;
          if (
            this.questionTypes.ASSERTION_REASON == type ||
            this.questionTypes.SINGLE_CORRECT == type ||
            this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
            this.questionTypes.COMPREHENSION_2Q_SA == type ||
            this.questionTypes.COMPREHENSION_2Q_MM == type ||
            this.questionTypes.COMPREHENSION_3Q_SA == type ||
            this.questionTypes.TC_2Q_SA == type ||
            this.questionTypes.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find((o) => o.id == answer.answer.option_id);
              if (option) {
                yourAnswer.push(option.index);
                option.correct_answer = true;
              }
              break;

            case 2:
              answer.answer.option_id.map((a) => {
                option = options.find((o) => o.id == a);
                if (option) {
                  yourAnswer.push(option.index);
                  option.correct_answer = true;
                }
              });
              break;
          } // end of switch
        }
      }

      responseData.options = options;
      responseData.yourAnswer = yourAnswer.join(", ");
      responseData.correctAnswer = correctAnswer.join(", ");
      return responseData;
    },
    getCQRType2(q) {
      let responseData = {
        yourAnswer: "",
        correctAnswer: q.correct_answer.split("##"),
      };
      if (
        responseData.correctAnswer.length &&
        responseData.correctAnswer.length > 0
      ) {
        responseData.correctAnswer = responseData.correctAnswer.join(" - ");
      }
      if (q.user_selected_answer) {
        let answer = JSON.parse(q.user_selected_answer);
        let yourAnswer = answer.answer ? parseFloat(answer.answer) : null;
        responseData.yourAnswer = yourAnswer;
      }

      return responseData;
    },
    generateQuestionObject(typeId, q) {
      let type = "";
      type = this.getQuestionType(typeId);
      let currentQuestion = {};
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      // let cqr = null;
      // switch (type) {
      //   case 1:
      //     cqr = this.getCQRType1(typeId, q);
      //     currentQuestion.options = cqr.options;
      //     currentQuestion.yourAnswer = cqr.yourAnswer;
      //     currentQuestion.correctAnswer = cqr.correctAnswer;
      //     break;
      //   case 2:
      //     cqr = this.getCQRType2(q);
      //     currentQuestion.correct_answer = cqr.yourAnswer;
      //     currentQuestion.yourAnswer = cqr.yourAnswer;
      //     currentQuestion.correctAnswer = cqr.correctAnswer;
      //     break;
      //   case 3:
      //     cqr = this.separateOptions(q, 1);
      //     currentQuestion.options_abc = cqr.options_abc;
      //     currentQuestion.options_pqr = cqr.options_pqr;
      //     currentQuestion.yourAnswer = cqr.yourAnswer;
      //     currentQuestion.correctAnswer = cqr.correctAnswer;

      //     break;
      //   case 4:
      //     cqr = this.separateOptions(q, 2);
      //     currentQuestion.options_abc = cqr.options_abc;
      //     currentQuestion.options_pqr = cqr.options_pqr;
      //     currentQuestion.options = cqr.op;
      //     currentQuestion.yourAnswer = cqr.yourAnswer;
      //     currentQuestion.correctAnswer = cqr.correctAnswer;

      //     break;
      //   case 6:
      //     cqr = this.getCQRType2(q);
      //     currentQuestion.correct_answer = cqr.yourAnswer;
      //     currentQuestion.yourAnswer = cqr.yourAnswer;
      //     currentQuestion.correctAnswer = cqr.correctAnswer;
      //     break;
      // }
      return currentQuestion;
    },
    getQuestionType(id) {
      if (
        id == this.questionTypes.ASSERTION_REASON ||
        id == this.questionTypes.MULTIPLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
        id == this.questionTypes.COMPREHENSION_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MM ||
        id == this.questionTypes.COMPREHENSION_2Q_MA ||
        id == this.questionTypes.COMPREHENSION_3Q_SA ||
        id == this.questionTypes.COMPREHENSION_3Q_MA ||
        id == this.questionTypes.TC_2Q_SA ||
        id == this.questionTypes.TC_3Q_SA
      ) {
        return 1;
      } else if (id == this.questionTypes.INTEGER) {
        return 2;
      } else if (id == this.questionTypes.MATRIX_MATCH) {
        return 3;
      } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
        return 4;
      } else if (
        id == this.questionTypes.COMPREHENSION ||
        id == this.questionTypes.TC
      ) {
        return 5;
      } else if (id == this.questionTypes.SUBJECTIVE ||
        id == this.questionTypes.COMPREHENSION_2Q_NU ||
        id == this.questionTypes.SUBJECTIVEINTEGER) {
        return 6;
      }
    },
    onClose(data) {
      this.status = data.status;
      if (data.redirectTo) {
        this.redirectTo(data.redirectTo);
      }
      if (data.action === "yes" && data.refId === "removeBookmark") {
        this.removeBookmark();
      }
    },
    separateOptions(q, type) {
      let options = q.options;
      let op = [];
      let options_abc = [];
      let options_pqr = [];

      let correctAnswer = [];
      let yourAnswer = [];

      options.forEach((option) => {
        // separate options: options (op), options_abc, options_pqr
        if (option.column == 1) {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : "";
          options_abc.push(option);
        } else if (option.column == 2) options_pqr.push(option);
        else {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : false;
          op.push(option);
        }
      });

      // get correct answer
      if (type == 2) {
        // matrix match options
        op.forEach((o, idx) => {
          if (parseInt(o.correct_answer)) {
            correctAnswer.push(o.index);
            // op[idx].correct_answer = false;
          }
        });
      }
      if (type == 1) {
        // matrix match
        options_abc.forEach((o, idx) => {
          if (o.correct_answer > "") {
            correctAnswer.push({
              index: o.index,
              value: o.correct_answer,
            });
            options_abc[idx].correct_answer = o.correct_answer;
          }
        });
      }

      if (type == 1) {
        // type = 1 : matrix match
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            answer.answer.map((a) => {
              let option = options_abc.find((o) => o.id == a.option_id);
              if (option) {
                yourAnswer.push({
                  index: option.index,
                  value: a.value,
                });
                option.correct_answer = a.value;
              }
            });
          }
        }
        let ya = yourAnswer.map((answer) => {
          let ans = answer.index + ": " + this.separateVals(answer.value);
          return ans;
        });
        ya = ya.join(" | ");
        let ca = correctAnswer.map((answer) => {
          let ans = answer.index + ": " + this.separateVals(answer.value);
          return ans;
        });
        ca = ca.join(" | ");
        yourAnswer = ya;
        correctAnswer = ca;
      } else if (type == 2) {
        // type = 2 : matrix match options
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            let option = op.find((o) => o.id == answer.answer.option_id);
            if (option) {
              yourAnswer.push(option.index);
              option.correct_answer = true;
            }
          }
        }
        yourAnswer = yourAnswer.join(", ");
        correctAnswer = correctAnswer.join(", ");
      }

      return {
        op,
        options_abc,
        options_pqr,
        yourAnswer,
        correctAnswer,
      };
    },
    separateVals(value) {
			if (value) {
				value = value.split('##');
				let valueToReturn = [];
				value.map((v) => {
					if (v.trim() > '') {
						valueToReturn.push(v);
					}
				});
				return valueToReturn.join(', ');
			} else {
				return '';
			}
		},
		separateOptions(q, type) {
			let options = q.options;
			let op = [];
			let options_abc = [];
			let options_pqr = [];

			let correctAnswer = [];
			let yourAnswer = [];

			options.forEach((option) => {
				// separate options: options (op), options_abc, options_pqr
				if (option.column == 1) {
					option.correct_answer = option.correct_answer
						? option.correct_answer
						: '';
					options_abc.push(option);
				} else if (option.column == 2) options_pqr.push(option);
				else {
					option.correct_answer = option.correct_answer
						? option.correct_answer
						: false;
					op.push(option);
				}
			});

			// get correct answer
			if (type == 2) {
				// matrix match options
				op.forEach((o, idx) => {
					if (parseInt(o.correct_answer)) {
						correctAnswer.push(o.index);
						op[idx].correct_answer = false;
					}
				});
			}
			if (type == 1) {
				// matrix match
				options_abc.forEach((o, idx) => {
					if (o.correct_answer > '') {
						correctAnswer.push({
							index: o.index,
							value: o.correct_answer,
						});
						options_abc[idx].correct_answer = '';
					}
				});
			}

			if (type == 1) {
				// type = 1 : matrix match
				if (q.user_selected_answer) {
					let answer = JSON.parse(q.user_selected_answer);
					if (answer.answer) {
						answer.answer.map((a) => {
							let option = options_abc.find(
								(o) => o.id == a.option_id
							);
							if (option) {
								yourAnswer.push({
									index: option.index,
									value: a.value,
								});
								option.correct_answer = a.value;
							}
						});
					}
				}
				let ya = yourAnswer.map((answer) => {
					let ans =
						answer.index +
						': ' +
						this.separateVals(answer.value);
					return ans;
				});
				ya = ya.join(' | ');
				let ca = correctAnswer.map((answer) => {
					let ans =
						answer.index +
						': ' +
						this.separateVals(answer.value);
					return ans;
				});
				ca = ca.join(' | ');
				yourAnswer = ya;
				correctAnswer = ca;
			} else if (type == 2) {
				// type = 2 : matrix match options
				if (q.user_selected_answer) {
					let answer = JSON.parse(q.user_selected_answer);
					if (answer.answer) {
						let option = op.find(
							(o) => o.id == answer.answer.option_id
						);
						if (option) {
							yourAnswer.push(option.index);
							option.correct_answer = true;
						}
					}
				}
				yourAnswer = yourAnswer.join(', ');
				correctAnswer = correctAnswer.join(', ');
			}

			return {
				op,
				options_abc,
				options_pqr,
				yourAnswer,
				correctAnswer,
			};
			},
    addBookmark() {
      let reqData = {
        user_id: this.user.id,
        question_id: this.currentQuestion.id,
      };
      this.bookmarkQuestion = true;
      this.addBookmarkQuestion(reqData)
        .then((response) => {
          this.$toasted.success(`Question bookmark added successfully.`, {});
        })
        .catch((err) => {
          this.bookmarkQuestion = false;
          // this.$toasted.error(`Adding Bookmarked Question failed.`, {});
        });
      
    },
    removeBookmarkDialog(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: "Are you sure you want to remove bookmark?",
        refId: "removeBookmark",
      };
      this.modalWidth = "350px";
      this.status = true;
      this.$forceUpdate();
    },
    removeBookmark() {
      let reqData = {
        user_id: this.user.id,
        question_id: this.currentQuestion.id,
      };

      this.removeBookmarkQuestion(reqData)
        .then((response) => {
          this.$toasted.success(`Question bookmark removed successfully.`, {});
        })
        .catch((err) => {
          this.$toasted.error(`Remove Bookmarked Question failed.`, {});
        });
      this.bookmarkQuestion = false;
    },
    requestCreateTest() {
      if (!this.checkStudentUpgraded()) {
        this.$root.showLoader = true;

        let reqData = {
          test_name: this.testName, // from constansts.js
          chapter_id: this.currentQuestion.chapterId ? [this.currentQuestion.chapterId] : [],
          subject_id: this.currentQuestion.subjectId,
          required_pyq: 0,
          topic_id: this.currentQuestion.topic_id
            ? [this.currentQuestion.topic_id]
            : [],
          question_types: [this.currentQuestion.question_type],
          test_sub_type: this.testSubType, // from constansts.js
          test_type: this.testType, // from constansts.js
        };
        this.createTestForPracticeSession(reqData)
          .then((response) => {
            this.removeSessionData();
            localStorage.setItem(
              "session_start",
              response.practice_session.start_time
            );
            localStorage.setItem(
              'current_question_page',
              this.page
            );
            localStorage.setItem("previousPath", this.$route.path);
            this.$router.push({
              name: "practice-session-question-view",
              params: {
                practice_session_id: response.practice_session.id,
                subject_id: response.practice_session.subject_id,
                test_id: response.id,
                topicsSelected: this.currentQuestion.topic_id && this.currentQuestion.topic_id !== null && this.currentQuestion.topic_id !== 0 ? 1 : 0,
              },
            });
            this.$root.showLoader = false;

          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    checkStudentUpgraded() {
      this.status = this.checkStudentUpgradedHelper(
        this.user.subscription_details
      );
      this.cComponent =
        "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp";
      (this.modalwidth = "500px"), (this.alertBoxData = {});
      return this.status;

    },

    redirectTo(route) {
      this.$router.push({
        name: route,
      });
    },

    getSubTopics(subTopicId) {
      if ((subTopicId || this.selectedTopic.topic_id) && this.isPreview) {
        let reqData = {
          level: 5,
          parent: subTopicId || this.selectedTopic.topic_id,
          // this.$root.showLoader = true;
        };
        this.subTopics = [];
        this.concepts = [];
        //this.selectedSubTopic = {};
        //this.selectedConcept = {};
        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            let subTopicList = [];
            response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { subtopic_id: x.id, title: x.title };
              subTopicList.push(c);
              //return c;
            });
            this.$forceUpdate();
            this.subTopics = subTopicList;
          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },
    getConcepts(conceptId) {
      this.concepts = [];
      if ((conceptId || this.selectedSubTopic.subtopic_id) && this.isPreview) {
        let reqData = {
          level: 6,
          parent: conceptId || this.selectedSubTopic.subtopic_id,
          // this.$root.showLoader = true;
        };
        //this.selectedConcept = {};
        this.concepts = [];
        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            this.concepts = response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { concept_id: x.id, title: x.title };
              return c;
            });
          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },
    getSkillSets(skillsetId) {
      this.skillset = [];
      let reqData = {
        keys: ["ANSWER_TYPE"],
      };
      this.getRefData(reqData)
        .then(response => {
          // this.$root.showLoader = false;
          this.skillset = response.ANSWER_TYPE.map(x => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            return c;
          });
        })
        .catch(err => {
          // this.$root.showLoader = false;
        });
    },
    onSelectedSubTopic(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.subtopic_id = e.subtopic_id;
        this.currentQuestionToBeEdited.subtopicName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.subtopic_id = e.subtopic_id;
        this.currentQuestion.subtopicName = e.title;
      }
      this.getConcepts(e.subtopic_id);
    },
    onSelectedConcept(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.concept_id = e.concept_id;
        this.currentQuestionToBeEdited.conceptName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.concept_id = e.concept_id;
        this.currentQuestion.conceptName = e.title;
      }
    },
    onselectedSkillset(e) {
      sessionStorage.removeItem("selectedQuestionIds");
      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.answer_type = e.id;
        this.currentQuestionToBeEdited.skillsetName = e.value;
      }
      if (this.currentQuestion) {
        this.currentQuestion.answer_type = e.id;
        this.currentQuestion.skillsetName = e.value;
      }
    },

    getChapters(subjectId, subSubject) {
      if (subjectId && this.isPreview) {
        this.chapters = [];
        let reqData = {
          level: 3,
          parent: subjectId,
          sub_subject: subSubject,
        };
        // this.$root.showLoader = true;
        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            this.chapters = response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { chapter_id: x.id, title: x.title };
              return c;
            });
          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },

    getTopics(chapterId) {
      if ((chapterId || this.selectedChapter.chapter_id) && this.isPreview) {
        let reqData = {
          level: 4,
          parent: chapterId || this.selectedChapter.chapter_id,
        };
        // this.selectedSubTopic = {};
        this.subTopics = [];
        //this.selectedConcept = {};
        this.concepts = [];
        // this.$root.showLoader = true;
        if (this.isSearchAnotherQ) {
          this.selectedTopic.topic_id = null;
          this.selectedTopic.title = null;
        }

        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            this.topics = response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { topic_id: x.id, title: x.title };
              return c;
            });

          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },

    onSelectChapter(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.chapterId = e.chapter_id;
        this.currentQuestionToBeEdited.chapterName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.chapterId = e.chapter_id;
        this.currentQuestion.chapterName = e.title;
      }
      this.selectedSubTopic.subtopic_id = null;
      this.selectedTopic.topic_id = null;
      this.selectedTopic.title = null;
      this.getTopics(e.chapter_id);
    },
    onSelectedTopic(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.topic_id = e.topic_id;
        this.currentQuestionToBeEdited.topicName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.topic_id = e.topic_id;
        this.currentQuestion.topicName = e.title;
      }
      this.getSubTopics(e.topic_id);
      //this.getConcepts(e.topic_id);
    },
    onselectedDifficulty(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.difficultyId = e.id;
        this.currentQuestionToBeEdited.difficultyName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.difficultyId = e.id;
        this.currentQuestion.difficultyName = e.title;
      }
    },

    validate() {
      let isValid = true;
      if (!this.selectedChapter.chapter_id) {
        this.$toasted.error("Please Select Chapter");
        isValid = false;
      }
      // if (!this.selectedTopic.topic_id && this.isDBTest) {
      //   this.$toasted.error("Please Select Topic");
      //   isValid = false;
      // }
      if (!this.selectedDifficultyLevel.id && this.isDBTest) {
        this.$toasted.error("Please Select Difficulty Level");
        isValid = false;
      }
      if (!this.selectedSkillSet.id && this.isDBTest) {
        this.$toasted.error("Please Select skill set");
        isValid = false;
      } //Validity check!
      // if (!this.selectedSubTopic.subtopic_id && this.isDBTest) {
      //   this.$toasted.error("Please Select SubTopic");
      //   isValid = false;
      // }
      // if (!this.selectedConcept.concept_id && this.isDBTest) {
      //   this.$toasted.error("Please Select Concept");
      //   isValid = false;
      // }

      return isValid;
    },

    editQuestion() {
      if (this.isEditing) {
        // saving the edited data
        if (this.validation(this.currentQuestionToBeEdited)) {
          this.updateEditedQuestion();
        }
      } else {
        // edit current question
        this.currentQuestionToBeEdited = {};
        delete this.currentQuestionToBeEdited.childQuestions;
        this.currentQuestionToBeEdited = _.cloneDeep(this.currentQuestion);
        if (
          this.currentQuestion.question_type == this.questionTypes.COMPREHENSION ||
          this.currentQuestion.question_type == this.questionTypes.TC
        ) {
          this.currentQuestionToBeEdited.question_text = this.currentQuestion.passage;
          this.currentQuestionToBeEdited.id = this.currentQuestion.id;
          let childQuestions = this.subjectQuestionTypeList.filter(
            q => q.parent_id === this.currentQuestion.id && q.id !== this.currentQuestion.id
          );
          
          this.currentQuestionToBeEdited.questions = [];
          childQuestions.map(q => {
            this.currentQuestionToBeEdited.questions.push( _.cloneDeep(q));
          });
        }

        this.getTopics(this.currentQuestion.chapterId);
        this.isEditing = true;
        this.getSubTopics(this.currentQuestion.topic_id);
        this.getConcepts(this.currentQuestion.subtopic_id);
        
        this.$forceUpdate();
        this.$nextTick(() => {
          this.$refs.chapterName.focus();
        });
      }
    },

    updateEditedQuestion() {
      let stepOneData = {};
      let list = [];
      let forUpdate = true;
      let q = _.cloneDeep(this.currentQuestionToBeEdited);
      if (this.validate()) {
        this.$root.showLoader = true;
        let obj = {
          id: q.id,
          question_text: q.question_text,
          question_type: q.questionType.id,
          subtype: q.subtype ? q.subtype : null,
          data_type_id: q.chapterId,
          topic_id: q.topic_id,
          subtopic_id: q.subtopic_id,
          concept_id: q.concept_id,
          answer_type: q.answer_type,
          difficulty: q.difficultyId,
          // correct_marks: q.correct_marks.toString(),
          // negative_marks: q.negative_marks.toString(),
          // partial_marking: q.partial_marking.toString(),
          questions: q.questions ? q.questions : [],
          solution: q.solution,
          hints: this.getHintsForRequest(q.hints),
        };

        if (
          q.questionType.id === this.questionTypes.INTEGER ||
          q.questionType.id === this.questionTypes.SUBJECTIVE ||
          q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER
        ) {
          obj.correct_answer = q.correct_answer;
        } else {
          obj.correct_answer = "-";
        }
        if (
          q.questionType.id === this.questionTypes.ASSERTION_REASON ||
          q.questionType.id === this.questionTypes.MULTIPLE_CORRECT ||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT_SEC2 ||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT
        ) {
          obj.options = q.options;
        } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH) {
          obj.options = q.options_abc.concat(q.options_pqr);
        } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH_OPTION) {
          obj.options = q.options.concat(q.options_abc).concat(q.options_pqr);
        }

        let reqData = obj

        this.editExternalQuestion(reqData)
          .then(response => {
            this.$root.showLoader = false;
            this.$toasted.success(`Success\nQuestion updated successfully!`, {
              icon: "check_circle",
            });
            this.isEditing = false;
            this.scrollToTop();
            this.getQuestion();
          })
          .catch(err => {
            this.$root.showLoader = false;
          });
      }
    },

    scrollToTop() {
      let content = this.$refs.questionBox;
      if (content) content.scrollTop = 0;
      let scrollElem = document.getElementsByClassName("v-application--wrap");
      scrollElem[0].scrollIntoView();
    },
  },
};
</script>
